import { axiosAuthClient } from "..";
import { handleError } from "../../utils/errors";

class AuthService {
  login = async ({ email, password }) => {
    try {
      const response = await axiosAuthClient.post(
        "/login",
        {
          email,
          password,
        },
        { withCredentials: true }
      );
      if (response.status !== 201) {
        throw new Error();
      }

      const { accessToken, refreshToken, adminUser } = response.data.data;

      return {
        accessToken,
        refreshToken,
        adminUser,
      };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while logging in, status:" + err.code
      );
    }
  };

  logout = async () => {
    try {
      const response = await axiosAuthClient.post(
        "/logout",
        {},
        {
          withCredentials: true,
        }
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return;
    } catch (err) {
      throw handleError(err, "Error occurred while logging out");
    }
  };

  refresh = async () => {
    try {
      const response = await axiosAuthClient.get("/refresh-token", {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      const { accessToken } = response.data.data;
      return { accessToken };
    } catch (err) {
      throw handleError(err, "Error occurred while refresh token");
    }
  };
}

const authService = new AuthService();

export default authService;
